module.exports = __webpack_public_path__ + "img/logo-ct.6d0d963c.png";